import axios from "axios";
import { getAccountData ,isGeminiUser,getPrimaryAccount} from "../utils/sessionUtil";
import { ContentMessagesAPIs } from "./drupalServices";
import { getBaseUrl,getBhoomiURL } from "../utils/commonUtil";
import { getJwtToken } from "../Auth0/SessionProvider";

const geminiUser = process.env.REACT_APP_GEMINI_USER === 'true';

const baseURL = (`${!geminiUser ? process.env.REACT_APP_API_BASE_URL: process.env.REACT_APP_CSR_API_BASE_URL}/donor-portal/api`) || "/";
  const  bhoomiBaseUrl =  process.env.REACT_APP_BHOOMI_URL;
const instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*"
  }
});

const bhoomiInstance = axios.create({
  baseURL:bhoomiBaseUrl,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "application":geminiUser?"GDP":"DP"
  }
});


const formDataInstance = axios.create({
  baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*"
  }
});

const downloadInstance = axios.create({
  responseType: "blob",
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*"
  }
});

downloadInstance.interceptors.request.use( async (config) => {
  const token = await getJwtToken();
  if(!token) {
    throw new axios.Cancel('Request cancelled due to invalid token');
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.request.use( async (config) => {
  const token = await getJwtToken();
  if(!token) {
    throw new axios.Cancel('Request cancelled due to invalid token');
  }
  if (token) {
    if(!config.isBhoomiUrl)
    {
      config.headers.Authorization = `Bearer ${token}`;
    }
    else
    {
      config.headers['authtoken'] = token;
      config.auth = {
        username:process.env.BHOOMI_USERNAME,
        password:process.env.BHOOMI_PASSWORD
      }
    }
  }
  return config;
});

bhoomiInstance.interceptors.request.use( async (config) => {
  const token = await getJwtToken();
  if(!token) {
    throw new axios.Cancel('Request cancelled due to invalid token');
  } 
  if (token) {
      config.headers['authtoken'] = token;
      config.withCredentials = true;
      config.auth = {
        username:process.env.REACT_APP_BHOOMI_USERNAME,
        password:process.env.REACT_APP_BHOOMI_PASSWORD
      }
    
  }
  return config;
});


formDataInstance.interceptors.request.use( async (config) => {
  const token = await getJwtToken();
  if(!token) {
    throw new axios.Cancel('Request cancelled due to invalid token');
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const openAdditionalAccount = {
  setInitialContribution: requestBody => {
    return instance.put(
      `/party/${getAccountData().partyId}/addIdentifierToParty`,
      requestBody.payload
    );
  },
  fetchAlertContents: () => {
    const name = "OOA";
    return ContentMessagesAPIs.getAlertMessagesFromDrupal({ name })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return [];
      });
  }
};

export const postJson = {
  postCalls: (url, body,config) => {
    return bhoomiInstance.post(url, body,config);
  }
};


export const grant = {
  getSingleGrantByAccountIdStartDateAndEndDate: ({
    userId,
    startDate,
    endDate
  }) => {
    return instance.get(
      `/grant/${userId}/findSingleGrantByAccountIdStartDateAndEndDate`,
      {
        params: {
          startDateStr: startDate,
          endDate: endDate
        }
      }
    );
  },
  udpatePendingSpawn: ({ accountId, updatedGrant }) => {
    return instance.post(
      `/grant/${accountId}/updatePendingSpawn`,
      updatedGrant
    );
  },
  updateSingleGrant: ({ accountId, updatedGrant }) => {
    return instance.post(`/grant/${accountId}/updateSingleGrant`, updatedGrant);
  },
  updateRecurringGrant: ({ accountId, updatedGrant }) => {
    return instance.post(
      `/grant/${accountId}/updateRecurringGrant`,
      updatedGrant
    );
  },

  updateRecurringGrantPurposeEdit: ({ accountId, updatedGrant }) => {
    return instance.post(
      `/grant/${accountId}/updatePurposeAndRecognitionRecurringGrant`,
      updatedGrant
    );
  },
  
  findRecurringGrantByScheduleId: ({ userId, scheduleId }) => {
    return instance.get(`/grant/${userId}/findRecurringGrantByScheduleId`, {
      params: {
        scheduleId: scheduleId
      }
    });
  },
  findGrantDetailsByAccountIdAndGrantId: ({ userId, grantId }) => {
    return instance.get(
      `/grant/${userId}/findGrantDetailsByAccountIdAndGrantId`,
      {
        params: {
          grantId: grantId
        }
      }
    );
  },
  getSpawnBySpawnIdAndScheduleId: ({ userId, scheduleId, spawnId }) => {
    return instance.get(`/grant/${userId}/getSpawnBySpawnIdAndScheduleId`, {
      params: {
        scheduleId: scheduleId,
        spawnId: spawnId
      }
    });
  },
  cancelGrant: ({ userId, cancelData }) => {
    return instance.put(`/grant/${userId}/cancelGrant`, cancelData);
  },
  cancelPendingSpawnPayment: ({
    userId,
    scheduleId,
    pendingSpawnId,
    cancelData
  }) => {
    return instance.post(
      `/grant/${userId}/cancelPendingSpawnPayment`,
      cancelData,
      {
        params: {
          scheduleId: scheduleId,
          pendingSpawnId: pendingSpawnId
        }
      }
    );
  },
  addAnotherPaymentForSchedule: ({ userId, scheduleId }) => {
    return instance.post(
      `/grant/${userId}/addAnotherPaymentForSchedule`,
      null,
      {
        params: {
          scheduleId: scheduleId
        }
      }
    );
  },
  updateIndividualSpawn: ({ userId, updateData }) => {
    return instance.post(`/grant/${userId}/updateIndividualSpawn`, updateData);
  },
  getPoolsPendingContribution: ({ userId }) => {
    return instance.get(
      `/grant/${userId}/getPoolsAssociatedWithPendingContributionForAccount`
    );
  },
  getAdminFee: ({ userId }) => {
    return instance.get(`/grant/${userId}/getCurrentAdminFeeAmountForAccount`);
  },
  suggestCharity: ({ userId, charityData }) => {
    return instance.post(`/granteeOrg/${userId}/suggestCharity`, charityData);
  },
  addCharity: ({ userId, charityData }) => {
    return instance.put(`/grant/${userId}/addCharity`, charityData);
  }
};

export const contribution = {};

export const profile = {
  getAccountAdvisors: ({ accountId }) => {
    return instance.get(`/profile/${accountId}/getAccountAdvisors`);
  },
  getAccountProfileLegacyByAccountIdAndPartyId: ({ userId, partyId }) => {
    if (!userId) {
      throw Error("User Id is mandatory!");
    }
    const params = {};
    if (partyId) {
      params.partyId = partyId;
    }
    return instance.get(
      `/profile/${userId}/getAccountProfileLegacyByAccountIdAndPartyId`,
      {
        params
      }
    );
  }
};

/** My Account - end */

/** Investments and Recommend an exchange - start */

export const exchangesApi = {
  customPoolFee: ({ poolId, currentDate }) => {
    return instance.get(`/exchange/getCustomPoolFeeByPoolIdAndDate?poolId=${poolId}&date=${currentDate}`);
  },
};

export const findInvestmentPoolOptionsByAccountIdStartDateAndEndDate = ({
  userId,
  startDate,
  endDate
}) => {
  if (!userId) {
    throw Error("User Id is mandatory!");
  }
  return instance.get(
    `/investment/${userId}/findInvestmentPoolOptionsByAccountIdStartDateAndEndDate`,
    {
      params: {
        startDateStr: startDate,
        endDateStr: endDate
      }
    }
  );
};

export const getActiveExchangeScheduleCount = ({ userId }) => {
  return instance.get(`/exchange/${userId}/getActiveExchangeScheduleCount`);
};

export const getTradeCutOffDateAndTime = ({ userId }) => {
  const params = {};
  if (userId) {
    params.accountId = userId;
  }
  return instance.get(`/getTradeCutOffDateAndTime`, {
    params
  });
};

export const getPendingTIFF = ({ userId }) => {
  return instance.get(`/exchange/${userId}/hasPendingTIFF`);
};

export const findInvestmentOptionsByAccountIdFromDateAndToDate = ({
  accountId,
  startDate,
  endDate
}) => {
  return instance.get(
    `/investmentOptions/findInvestmentOptionsByAccountIdFromDateAndToDate`,
    {
      params: {
        accountId: accountId,
        fromDate: startDate,
        toDate: endDate
      }
    }
  );
};

export const createNewSingleExchange = ({ accountId, data }) => {
  return instance.put(`/exchange/${accountId}/newSingleExchange`, data);
};

export const createNewRecurringExchange = ({ accountId, data }) => {
  return instance.put(`/exchange/${accountId}/newRecurringExchange`, data);
};

export const findSingleExchangeDetailsByAccountIdAndExchangeId = ({
  accountId,
  exchangeId
}) => {
  return instance.get(
    `/exchange/${accountId}/findSingleExchangeDetailsByAccountIdAndExchangeId`,
    {
      params: {
        exchangeId
      }
    }
  );
};

export const findRecurringExchangeDetailsByAccountIdAndScheduleId = ({
  accountId,
  exchangeId
}) => {
  return instance.get(
    `/exchange/${accountId}/findRecurringExchangeDetailsByAccountIdAndScheduleId`,
    {
      params: {
        scheduleId: exchangeId
      }
    }
  );
};

export const findExchangeSpawnDetailsByScheduleIdAndSpawnId = ({
  accountId,
  exchangeId,
  exchPendingSpawnId
}) => {
  return instance.get(
    `/exchange/${accountId}/findExchangeSpawnDetailsByScheduleIdAndSpawnId`,
    {
      params: {
        exchangeScheduleId: exchangeId,
        exchPendingSpawnId
      }
    }
  );
};

export const updateSingleExchange = ({ accountId, data }) => {
  return instance.put(`/exchange/${accountId}/updateSingleExchange`, data);
};

export const updateRecurringExchange = ({ accountId, data }) => {
  return instance.put(`/exchange/${accountId}/updateRecurringExchange`, data);
};

export const cancelSingleSpawn = ({
  userId,
  exchScheduleId,
  exchPendingSpawnId
}) => {
  return instance.post(
    `/exchange/${userId}/cancelSpawnForExchangeSchedule`,
    null,
    {
      params: {
        exchangeScheduleId: exchScheduleId,
        exchPendingSpawnId
      }
    }
  );
};

export const reverseSingleSpawn = ({
  userId,
  exchScheduleId,
  exchPendingSpawnId
}) => {
  return instance.post(`/exchange/${userId}/reverseExchPendingSpawn`, null, {
    params: {
      exchangeScheduleId: exchScheduleId,
      exchPendingSpawnId
    }
  });
};

export const addAnotherExchangeForSchedule = ({ userId, txnId }) => {
  return instance.put(
    `/exchange/${userId}/addAnotherExchangeForSchedule`,
    null,
    {
      params: {
        exchangeScheduleId: txnId
      }
    }
  );
};

export const cancelAllSpawnsForExchangeSchedule = ({ userId, txnId }) => {
  return instance.post(
    `/exchange/${userId}/cancelAllSpawnsForExchangeSchedule`,
    null,
    {
      params: {
        exchangeScheduleId: txnId
      }
    }
  );
};

export const editExchangeSpawnByScheduleId = ({ accountId, data }) => {
  return instance.post(
    `/exchange/${accountId}/editExchangeSpawnByScheduleId`,
    data
  );
};

export const getCSRBusinessFunctionFromGemini = () => {
  return instance.get(`/user/fetchCSRBusinessFunctions`);
};

export const getfindAcctDetailsForCSRUserByAcctId = (
  dafAccountId,
  ciPartyId
) => {
  let params = { accountId: dafAccountId };

  if (ciPartyId && ciPartyId !== "null") {
    params.partyId = ciPartyId;
  }

  return instance.get(`/account/findAcctDetailsForCSRUserByAcctId`, {
    params
  });
};

/** Investments and Recommend an exchange - end */

export const sendCustomerQueryEmail = ({ partyId, customerData }) => {
  return instance.post(
    `/email/${partyId}/sendCustomerQueryEmail`,
    customerData
  );
};

const download = (response, filename) => {
  // For IE
  if (navigator.appVersion.toString().indexOf(".NET") > 0) {
    window.navigator.msSaveBlob(response.data, filename);
  } else {
    let tempLink = document.createElement("a");
    tempLink.href = URL.createObjectURL(response.data);
    tempLink.setAttribute("download", filename);
    tempLink.setAttribute("target", "_blank");

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
}

export const downloadFileFromUrl = url => {
  let apiUrl = `${getBaseUrl()}` + url;

  downloadInstance
    .get(apiUrl)
    .then(response => {
      var fileName = "";
      var disposition = response.headers["content-disposition"];

      if (disposition && disposition.indexOf("attachment") !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);

        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, "");
        }
      }

      download(response, fileName);
      
    })
    .catch(error => {
      console.log(error);
    });
};

export const exportExcelTableData = (url, params, filename) => {
  let apiUrl = `${getBaseUrl()}${url}`;

  if (filename === "Recurring Grant Activity.xlsx") {
    downloadInstance.get(apiUrl, params).then(response => {
      download(response, filename);
    }).catch(error => {
    })
  }
  else{
    downloadInstance.post(apiUrl, params).then(response => {
      download(response, filename);
    }).catch(error => {
    })
  }
  
}

export const logUiError = (url, data, isAuth) => {
  if(isAuth){
    return instance.post(url, data);
  }else {
    return axios.post(`${baseURL}${url}`, data, {
      headers:{
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*"
      }
    })
  }
  
}

export const findAdditionalAccountDetails = () => {
 return instance.get(`${getBaseUrl()}/donor-portal/api/account/${
  getPrimaryAccount().userId
}/findAdditionalAccountDetails${isGeminiUser() ? `?partyId=${getAccountData().partyId}`: ''}`);
};
